//This file is not in use hence translation not implemented
import {Button} from 'alm-react-components';

import SvgIcon from '../../common/SvgIcon';

import {Accordion, AccordionContent, AccordionItem, AccordionTrigger} from 'alm-react-components';

const HelpCenter = () => {
  return (
    <>
      <div className="flex-grow">
        <section className="dark:banner-gradient-gray dark:text-white">
          <div className="py-8 px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-6 h-[471px] flex items-center w-100 justify-center">
            <div className="mx-auto w-100 text-center items-center">
              <h1 className="mb-[58px] tracking-tight leading-7 lg:text-5xl md:text-4xl font-barlowLight font-light text-gray-900 dark:text-white">
                Help Center
              </h1>
              <form className=" md:w-[490px]">
                <label className="text-sm font-medium text-gray-900 sr-only dark:text-white h-[50px]">
                  Search
                </label>
                <div className="relative">
                  <input
                    type="search"
                    id="default-search"
                    className="block w-full p-4 pe-44 h-[50px] text-lg text-gray-900 border border-gray-300 rounded-lg"
                    placeholder=""
                  />
                  <Button
                    variant={'default'}
                    className="inline-flex items-center justify-center rounded-[0 6] py-4 px-4 w-40 h-[50px] absolute top-0 right-0 text-2xl font-opensansSemiBold font-opensansMedium"
                  >
                    Search
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </section>

        <section className="">
          <div className="w-[100%] mx-auto max-w-screen-xl px-4 lg:px-6 md:py-14">
            <div className="mx-auto">
              <dl className="grid grid-cols-1 gap-x-4 md:gap-y-4 lg:gap-y-16 text-center lg:grid-cols-4 md:grid-cols-2">
                <button
                  type="button"
                  className="dark:bg-fillMidGrayCard font-medium rounded-lg text-sm px-5 py-6 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 me-2 mb-2"
                >
                  <SvgIcon
                    iconName="account-billing"
                    svgProp={{
                      className: 'logo',
                      width: 63,
                      height: 62,
                    }}
                  />
                  <span className="ps-4 text-base">Account and Billing</span>
                </button>
                <button
                  type="button"
                  className="dark:bg-fillMidGrayCard font-medium rounded-lg text-sm px-5 py-6 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 me-2 mb-2"
                >
                  <SvgIcon
                    iconName="getting-started"
                    svgProp={{
                      className: 'logo',
                      width: 63,
                      height: 62,
                    }}
                  />
                  <span className="ps-4 text-base">Getting Started</span>
                </button>
                <button
                  type="button"
                  className="dark:bg-fillMidGrayCard font-medium rounded-lg text-sm px-5 py-6 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 me-2 mb-2"
                >
                  <SvgIcon
                    iconName="using-inner-stance"
                    svgProp={{
                      className: 'logo',
                      width: 63,
                      height: 62,
                    }}
                  />
                  <span className="ps-4 text-base">Using Inner Stance</span>
                </button>
                <button
                  type="button"
                  className="dark:bg-fillMidGrayCard font-medium rounded-lg text-sm px-5 py-6 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 me-2 mb-2"
                >
                  <SvgIcon
                    iconName="troubleshooting"
                    svgProp={{
                      className: 'logo',
                      width: 63,
                      height: 62,
                    }}
                  />
                  <span className="ps-4 text-base">Troubleshooting</span>
                </button>
              </dl>
            </div>
          </div>
        </section>

        <section>
          <div className="w-[100%] mx-auto md:px-32 md:pt-24 pt-24">
            <div className="mx-auto md:max-w-4xl lg: px-6">
              <Accordion type="single" collapsible className="w-full mt-1">
                <AccordionItem value="item-1" className="border-0">
                  <AccordionTrigger className="mb-3 bg-[#212930] px-6 py-7 rounded-lg common-accordian text-2xl font-sans font-normal hover:no-underline text-left">
                    Upgrading and downgrading your plan
                  </AccordionTrigger>
                  <AccordionContent className="text-base font-barlowLight ms-12">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                      Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                      when an unknown printer took a galley of type and scrambled it to make a type
                      specimen book.{' '}
                    </p>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="item-2" className="border-0">
                  <AccordionTrigger className="mb-3 bg-[#212930] px-6 py-7 rounded-lg common-accordian text-2xl font-sans font-normal hover:no-underline text-left">
                    Signing into your Inner Stance account
                  </AccordionTrigger>
                  <AccordionContent className="text-base font-barlowLight ms-12">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                      Lorem Ipsum has been the industry's.
                    </p>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="item-3" className="border-0">
                  <AccordionTrigger className="mb-3 bg-[#212930] px-6 py-7 rounded-lg common-accordian text-2xl font-sans font-normal hover:no-underline text-left">
                    Canceling your subscription
                  </AccordionTrigger>
                  <AccordionContent className="text-base font-barlowLight ms-12">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                      Lorem Ipsum has been the industry's.
                    </p>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="item-4" className="border-0">
                  <AccordionTrigger className="mb-3 bg-[#212930] px-6 py-7 rounded-lg common-accordian text-2xl font-sans font-normal hover:no-underline text-left">
                    Introduction to Inner Stance
                  </AccordionTrigger>
                  <AccordionContent className="text-base font-barlowLight ms-12">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                      Lorem Ipsum has been the industry's.
                    </p>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="item-5" className="border-0">
                  <AccordionTrigger className="mb-3 bg-[#212930] px-6 py-7 rounded-lg common-accordian text-2xl font-sans font-normal hover:no-underline text-left">
                    Contacting Inner Stance
                  </AccordionTrigger>
                  <AccordionContent className="text-base font-barlowLight ms-12">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                      Lorem Ipsum has been the industry's.
                    </p>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="item-6" className="border-0">
                  <AccordionTrigger className="mb-3 bg-[#212930] px-6 py-7 rounded-lg common-accordian text-2xl font-sans font-normal hover:no-underline text-left">
                    Changing ot resetting your password
                  </AccordionTrigger>
                  <AccordionContent className="text-base font-barlowLight ms-12">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                      Lorem Ipsum has been the industry's.
                    </p>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="item-7" className="border-0">
                  <AccordionTrigger className="mb-3 bg-[#212930] px-6 py-7 rounded-lg common-accordian text-2xl font-sans font-normal hover:no-underline text-left">
                    Live Sessions lorem ipsum
                  </AccordionTrigger>
                  <AccordionContent className="text-base font-barlowLight ms-12">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                      Lorem Ipsum has been the industry's.
                    </p>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="item-8" className="border-0">
                  <AccordionTrigger className="mb-3 bg-[#212930] px-6 py-7 rounded-lg common-accordian text-2xl font-sans font-normal hover:no-underline text-left">
                    Where can I down load the Inner Stance App
                  </AccordionTrigger>
                  <AccordionContent className="text-base font-barlowLight ms-12">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                      Lorem Ipsum has been the industry's.
                    </p>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        </section>
        {/* <section className="dark:text-white ">
                <div  className={`fixed bottom-[25px] right-[25px] ${!openFrame?"hidden":""}`}>
             <Button
                            variant={"default"}
                            onClick={() =>{ setOpenFrame(false)
                                window.close()
                            }}
                            className="inline-flex right-[-315px] items-center justify-center rounded-3xl text-xl font-opensansBold my-2 ml-4 py-3 md: px-6 h-auto relative">
                            X
                        </Button>
                        <iframe name="iframe1" src="target.html" width="400" height="600"></iframe>
                </div>
                <div className="py-8 px-6 mx-auto max-w-screen-xl sm:py-16 lg:px-6 h-[471px] flex items-center w-100 justify-center">
                    <div className={`min-w-full flex flex-col text-center items-center ${openFrame?"static":"relative"}`}>
                      
                        <h1 className="md:mb-[58px] mb-[58px] tracking-tight leading-7 lg:text-5xl md:text-4xl text-4xl font-barlowLight font-light text-gray-900 dark:text-white">
                            Have More questions?
                        </h1>
                     
                        {!openFrame && <Button
                            variant={"default"}
                            onClick={() =>{ setOpenFrame(true)
                               window.open("https://ai-qa-chat-bot.alm-dev.innerstance.com/", 'iframe1')
                                }}
                            className="inline-flex items-center justify-center rounded-3xl text-xl font-opensansBold my-2 ml-4 py-3 md: px-6 h-auto md:absolute md:top-0 md:right-0">
                            <SvgIcon
                                iconName="support"
                                svgProp={{
                                    className: 'logo mr-3',
                                    width: 31,
                                    height: 30,
                                }}
                            />
                            Support
                        </Button>}
                        <div>
                            <Button className="inline-flex items-center justify-center dark:bg-white dark:text-black rounded-sm text-lg font-opensansSemiBold my-2 ml-4 py-4 md:px-10">
                                Submit a request
                            </Button>
                        </div>
                    </div>
                </div>
            </section> */}
      </div>
    </>
  );
};
export default HelpCenter;
